import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectElectronicTrading = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('electronic_trading')(jsonQuery),
);
